<template>
  <v-container>
    <v-layout row wrap class="mt-5">
      <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
        <v-card class="pa-4">
          <v-form ref="form" @submit.prevent="doReset">
            <v-container>
              <h1 class="primary--text">Reset password</h1>
              <p class="grey--text">Enter your email address to reset your password</p>
              <v-layout row wrap class="mb-2">
                <v-flex xs12>
                  <v-text-field
                    label="Email Address"
                    type="email"
                    v-model="credentials.email"
                    :rules="[validEmail]"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout class="align-center">
                <v-btn
                  depressed
                  color="primary"
                  type="submit"
                  :disabled="isLoading"
                >
                  Reset
                  <v-progress-circular class="ml-3" :indeterminate="true" :size="18" :width="2" v-if="isLoading"></v-progress-circular>
                </v-btn>
                <v-spacer></v-spacer>
                <router-link to="/auth/login" class="small">Back to Login?</router-link>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
    <MainFooter />
  </v-container>
</template>

<script>
import MainFooter from '@/components/Footer/MainFooter.vue'

export default {
  name: 'Reset',
  components: {
    MainFooter
  },
  data () {
    return {
      credentials: {
        email: ''
      },
      isLoading: false,
      error: null
    }
  },
  methods: {
    doReset () {
			this.isLoading = true
    }
  }
}
</script>
